/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Collapse, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  allExtras,
  Groups,
  extrasByGroup,
  extrasByProperty
} from './extras/ExtrasObjects';
export const ExtrasFilter = ({ setFiltersAndSort, filtersAndSort, label }) => {
  const [activeButtons, setActiveButtons] = useState({});

  // 1. Crear una lista de todos los extras aplicables
  const applicableExtras = filtersAndSort.propertyTypes.length
    ? filtersAndSort.propertyTypes.reduce((applicableExtras, propertyType) => {
        return [...applicableExtras, ...extrasByProperty[propertyType]];
      }, [])
    : allExtras;

  const handleButtonClick = button => {
    setActiveButtons({ ...activeButtons, [button]: !activeButtons[button] });
  };

  const handleCheckboxChange = (group, extra) => {
    const currentExtras = filtersAndSort.extras || [];
    const newExtra = `${group}.${extra}`;

    if (currentExtras.includes(newExtra)) {
      setFiltersAndSort({
        ...filtersAndSort,
        extras: currentExtras.filter(e => e !== newExtra)
      });
    } else {
      setFiltersAndSort({
        ...filtersAndSort,
        extras: [...currentExtras, newExtra]
      });
    }
  };

  const formatTitle = title => {
    return title.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase();
    });
  };

  return (
    <div>
      <Form.Label style={{ fontSize: '0.90rem', marginBottom: '8px' }}>
        {label}
      </Form.Label>
      {Object.keys(Groups).map(groupKey => (
        <div key={groupKey}>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              handleButtonClick(groupKey);
            }}
            aria-controls={`collapse-${groupKey}`}
            aria-expanded={activeButtons[groupKey]}
            style={{
              marginBottom: '10px',
              display: 'block',
              fontSize: '0.9rem',
              fontWeight: 'bold',
              textDecoration: 'none'
            }}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '0.25rem' }} />
            {formatTitle(Groups[groupKey])}
          </a>
          <Collapse in={activeButtons[groupKey]}>
            <div id={`collapse-${groupKey}`}>
              {extrasByGroup[Groups[groupKey]]
                .filter(extra => applicableExtras.includes(extra.label)) // 2. Filtrar extras por propiedad
                .map(extra => (
                  <Form.Check
                    key={extra.label}
                    type="checkbox"
                    id={extra.label}
                    label={extra.name}
                    onChange={() =>
                      handleCheckboxChange(Groups[groupKey], extra.label)
                    }
                    checked={filtersAndSort.extras?.includes(
                      `${Groups[groupKey]}.${extra.label}`
                    )}
                  />
                ))}
            </div>
          </Collapse>
        </div>
      ))}
    </div>
  );
};
